import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';

import Transition from '../assets/Transition';
import Header from '../components/Header';
import PageMeta from '../components/PageMeta';

import Image from '../assets/header.webp';

const Fallback = () => {
    useEffect(() => {
        document.title = "Uh oh!";
    });

    return (
        <motion.div
            initial={{translateX: 50, opacity: 0}}
            animate={{translateX: 0, opacity: 1}}
            exit={{translateX: 50, opacity: 0}}
            transition={{duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]}}>
            <PageMeta description="404 Not Found!" handle={`/404`} />
            <Header
                title="Something's wrong here"
                tagline={<>Let's try that one again. Maybe go <Link className='underline' to='/'>home</Link>?</>}
                image={Image}
                subtitle="ZOTY UNITED"/>
        </motion.div>
    );
};

export default Transition(Fallback);